"use client";

import { Typography } from "@drpcrd/shared/ui";
import { FadeInSection } from "../fade-in-section";
import {
  CreatorVideoCarousel,
  type CreatorVideoItem,
} from "../creator-video-carousel/creator-video-carousel";
import annaRupprechtProfileImg from "./assets/creator-carousel/anna-rupprecht.jpg";
import arkiTechnologyProfileImg from "./assets/creator-carousel/arki-technology.jpg";
import bambinoBeckyProfileImg from "./assets/creator-carousel/bambino-becky.jpg";
import dGradeProfileImg from "./assets/creator-carousel/d-grade.jpg";
import domFutbolProfileImg from "./assets/creator-carousel/dom-futbol.jpg";
import emilyOnToastProfileImg from "./assets/creator-carousel/emily-on-toast.jpg";
import emsbalanceProfileImg from "./assets/creator-carousel/emsbalance.jpg";
import grimeGranProfileImg from "./assets/creator-carousel/grime-gran.jpg";
import harryKontkanenProfileImg from "./assets/creator-carousel/harry-kontkanen.jpg";
import hevNotHeatherProfileImg from "./assets/creator-carousel/hev-not-heather.jpg";
import isaacHpProfileImg from "./assets/creator-carousel/isaac-hp.jpg";
import lloydAndMattProfileImg from "./assets/creator-carousel/lloyd-and-matt.jpg";
import mattGreenProfileImg from "./assets/creator-carousel/matt-green.jpg";
import mohibSherazProfileImg from "./assets/creator-carousel/mohib-sheraz.jpg";
import robDoingRobProfileImg from "./assets/creator-carousel/rob-doing-rob.jpg";
import venjentProfileImg from "./assets/creator-carousel/venjent.jpg";

const CREATOR_MEDIA_BY_ID: Record<
  number,
  { thumbnail: string; profile: string; videoUrl: string; postUrl: string }
> = {
  112: {
    thumbnail: new URL(
      "./assets/creator-carousel/isaac-hp.webp",
      import.meta.url,
    ).toString(),
    profile: isaacHpProfileImg.src,
    videoUrl: new URL(
      "./assets/creator-carousel/isaac-hp.webm",
      import.meta.url,
    ).toString(),
    postUrl: "https://www.tiktok.com/@isaach.p/video/7621606650918505750",
  },
  1717233161: {
    thumbnail: new URL(
      "./assets/creator-carousel/emsbalance.webp",
      import.meta.url,
    ).toString(),
    profile: emsbalanceProfileImg.src,
    videoUrl: new URL(
      "./assets/creator-carousel/emsbalance.webm",
      import.meta.url,
    ).toString(),
    postUrl: "https://www.tiktok.com/@emsbalance/video/7611510027551067414",
  },
  94: {
    thumbnail: new URL(
      "./assets/creator-carousel/harry-kontkanen.webp",
      import.meta.url,
    ).toString(),
    profile: harryKontkanenProfileImg.src,
    videoUrl: new URL(
      "./assets/creator-carousel/harry-kontkanen.webm",
      import.meta.url,
    ).toString(),
    postUrl: "https://www.instagram.com/reel/DQpGtXtCFdR/",
  },
  37510: {
    thumbnail: new URL(
      "./assets/creator-carousel/mohib-sheraz.webp",
      import.meta.url,
    ).toString(),
    profile: mohibSherazProfileImg.src,
    videoUrl: new URL(
      "./assets/creator-carousel/mohib-sheraz.webm",
      import.meta.url,
    ).toString(),
    postUrl: "https://www.instagram.com/reel/DXoXr8xDMn4/",
  },
  1717233919: {
    thumbnail: new URL(
      "./assets/creator-carousel/rob-doing-rob.webp",
      import.meta.url,
    ).toString(),
    profile: robDoingRobProfileImg.src,
    videoUrl: new URL(
      "./assets/creator-carousel/rob-doing-rob.webm",
      import.meta.url,
    ).toString(),
    postUrl: "https://www.instagram.com/reel/DUI1lrODVjL/",
  },
  37420: {
    thumbnail: new URL(
      "./assets/creator-carousel/lloyd-and-matt.webp",
      import.meta.url,
    ).toString(),
    profile: lloydAndMattProfileImg.src,
    videoUrl: new URL(
      "./assets/creator-carousel/lloyd-and-matt.webm",
      import.meta.url,
    ).toString(),
    postUrl: "https://www.tiktok.com/@lloydandmatt/video/7640137112003562774",
  },
  157511447: {
    thumbnail: new URL(
      "./assets/creator-carousel/dom-futbol.webp",
      import.meta.url,
    ).toString(),
    profile: domFutbolProfileImg.src,
    videoUrl: new URL(
      "./assets/creator-carousel/dom-futbol.webm",
      import.meta.url,
    ).toString(),
    postUrl: "https://www.instagram.com/reel/DSacOCsDHox/",
  },
  34470: {
    thumbnail: new URL(
      "./assets/creator-carousel/matt-green.webp",
      import.meta.url,
    ).toString(),
    profile: mattGreenProfileImg.src,
    videoUrl: new URL(
      "./assets/creator-carousel/matt-green.webm",
      import.meta.url,
    ).toString(),
    postUrl: "https://www.tiktok.com/@mattgreen.jgm/video/7484282222078496002",
  },
  691145545: {
    thumbnail: new URL(
      "./assets/creator-carousel/d-grade.webp",
      import.meta.url,
    ).toString(),
    profile: dGradeProfileImg.src,
    videoUrl: new URL(
      "./assets/creator-carousel/d-grade.webm",
      import.meta.url,
    ).toString(),
    postUrl: "https://www.tiktok.com/@d.grade/video/7593375861382974742",
  },
  788708041: {
    thumbnail: new URL(
      "./assets/creator-carousel/emily-on-toast.webp",
      import.meta.url,
    ).toString(),
    profile: emilyOnToastProfileImg.src,
    videoUrl: new URL(
      "./assets/creator-carousel/emily-on-toast.webm",
      import.meta.url,
    ).toString(),
    postUrl: "https://www.instagram.com/reel/DRCxW27jH3V/",
  },
  1124612152: {
    thumbnail: new URL(
      "./assets/creator-carousel/bambino-becky.webp",
      import.meta.url,
    ).toString(),
    profile: bambinoBeckyProfileImg.src,
    videoUrl: new URL(
      "./assets/creator-carousel/bambino-becky.webm",
      import.meta.url,
    ).toString(),
    postUrl: "https://www.instagram.com/reels/DMNWF_KIpNg/",
  },
  144: {
    thumbnail: new URL(
      "./assets/creator-carousel/arki-technology.webp",
      import.meta.url,
    ).toString(),
    profile: arkiTechnologyProfileImg.src,
    videoUrl: new URL(
      "./assets/creator-carousel/arki-technology.webm",
      import.meta.url,
    ).toString(),
    postUrl: "https://www.instagram.com/reel/DVO0Jn9DkJ5/",
  },
  1092419119: {
    thumbnail: new URL(
      "./assets/creator-carousel/grime-gran.webp",
      import.meta.url,
    ).toString(),
    profile: grimeGranProfileImg.src,
    videoUrl: new URL(
      "./assets/creator-carousel/grime-gran.webm",
      import.meta.url,
    ).toString(),
    postUrl: "https://www.tiktok.com/@grimegran/video/7555528048662023446",
  },
  1717233159: {
    thumbnail: new URL(
      "./assets/creator-carousel/hev-not-heather.webp",
      import.meta.url,
    ).toString(),
    profile: hevNotHeatherProfileImg.src,
    videoUrl: new URL(
      "./assets/creator-carousel/hev-not-heather.webm",
      import.meta.url,
    ).toString(),
    postUrl:
      "https://www.tiktok.com/@hevnotheather2015/video/7604833182176791830",
  },
  484252447: {
    thumbnail: new URL(
      "./assets/creator-carousel/anna-rupprecht.webp",
      import.meta.url,
    ).toString(),
    profile: annaRupprechtProfileImg.src,
    videoUrl: new URL(
      "./assets/creator-carousel/anna-rupprecht.webm",
      import.meta.url,
    ).toString(),
    postUrl:
      "https://www.tiktok.com/@annarupprecht_studio/video/7443022686642572566",
  },
  165699176: {
    thumbnail: new URL(
      "./assets/creator-carousel/venjent.webp",
      import.meta.url,
    ).toString(),
    profile: venjentProfileImg.src,
    videoUrl: new URL(
      "./assets/creator-carousel/venjent.webm",
      import.meta.url,
    ).toString(),
    postUrl: "https://www.tiktok.com/@venjent/video/7478008285560360214",
  },
};

type BakedCreatorItem = {
  id: number;
  uuid: string;
  brand: string;
  mission: string;
  creatorSrc: string | null;
  socialAvatarSrc: string | null;
  slug: string;
};

type Props = {
  items: BakedCreatorItem[];
};

/**
 * Social proof section showing real creator campaigns made with Nutcake.
 */
export const BakedWithNutcakeClient = ({ items }: Props) => {
  const carouselItems: CreatorVideoItem[] = items.flatMap((item) => {
    const mappedMedia = CREATOR_MEDIA_BY_ID[item.id];
    if (!mappedMedia) return [];

    return [
      {
        image: mappedMedia.thumbnail,
        name: item.brand,
        handle: item.mission,
        localAvatar: mappedMedia.profile,
        avatar: null,
        socialAvatar: null,
        video: mappedMedia.videoUrl,
        href: mappedMedia.postUrl,
      },
    ];
  });

  return (
    <section className="px-3 sm:px-6 md:px-8">
      <div className="mx-auto max-w-5xl space-y-4 sm:space-y-6">
        <FadeInSection className="space-y-3">
          <Typography
            as="h2"
            weight="semibold"
            className="font-poppins text-primary-500 text-2xl leading-[105%] tracking-[-0.96px] sm:text-4xl sm:tracking-[-1.44px] lg:text-6xl lg:tracking-[-2.56px]"
          >
            Baked with <span className="text-primary-700">Nutcake</span>
          </Typography>
          <Typography
            size="sm"
            color="black"
            className="leading-2.75 sm:text-lg sm:leading-3"
          >
            Campaigns run end to end on the platform, from the brands you
            already know.
          </Typography>
        </FadeInSection>

        <FadeInSection>
          <CreatorVideoCarousel items={carouselItems} showDetails />
        </FadeInSection>
      </div>
    </section>
  );
};
